import { PhylloGender } from '@round/api';

export const genderAgeChartColors: Record<PhylloGender, string> = {
    MALE: '#55AAFF',
    FEMALE: '#FF5DBE',
    OTHERS: '',
};

export const colors: [string, string] = [genderAgeChartColors.MALE, genderAgeChartColors.FEMALE];
